import styled, { css } from "styled-components";

export const GiftCardsHeaderTitle = styled.h1(
    () => css`
        font-size: 14px;
        font-weight: 700;
    `
)

export const GiftCardsHeaderSubTitle = styled.span(
    () => css`
        font-size: 11px;
        margin-bottom: 13px;
    `
)